import { useMutation } from "@tanstack/react-query";
import { putApiAuthPassword } from "Infrastructure/Api/Api";
import { HttpStatusCode } from "Infrastructure/Models/HttpStatusCodes";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export function usePasswordSetMutation() {
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const mutation = useMutation({
		mutationFn: putApiAuthPassword,
		onSuccess: (data) => {
			if (data.status === HttpStatusCode.Ok) {
				showSnackbar("Heslo aktualizováno.", "success");
			} else {
				showSnackbar(t(Resources.Errors.Error500), "error");
			}
		},
	});

	return mutation;
}
